import { useAuth } from '../../context/AuthContext';
import { useEmergency } from '../../context/EmergencyContext';
import Sidebar from './Sidebar';
import ToastContainer from './Toast';
import EmergencyOverlay from './EmergencyOverlay';

export default function Layout({ children }) {
  const { isAuthenticated } = useAuth();
  const { isEmergencyActive, orgEmergency, communityEmergency, resolveEmergency, respondToEmergency } = useEmergency();

  return (
    <div style={{
      display: 'flex',
      height: '100vh',
      width: '100vw',
      overflow: 'hidden',
      background: 'var(--color-bg-secondary)',
    }}>
      {isAuthenticated && <Sidebar />}

      <div style={{
        flex: 1,
        overflow: 'auto',
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
      }}>
        {children}
      </div>

      <ToastContainer />

      {isEmergencyActive && (
        <EmergencyOverlay
          emergency={orgEmergency || communityEmergency}
          isCommunity={!orgEmergency && !!communityEmergency}
          onResolve={resolveEmergency}
          onRespond={respondToEmergency}
        />
      )}
    </div>
  );
}